import { SemanticCOLORS } from "semantic-ui-react";
import IEntityWithImage from "./interfaces/iEntityWithImage";

export default class Member implements IEntityWithImage {
    constructor(public id:string, public name:string, public role:string, public context:string) {}
    public toString(): string { return `${this.name} (${this.role} - ${this.context})`; }
    public color?:SemanticCOLORS
    public promtForPhoto?:string
    public imageId?:string
}